module.exports = __webpack_public_path__ + "img/crime-syndicate.7fc683e1.svg";